<template>
  <div id="app">
 
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  font-family:SourceHei;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
}
html,
body {
    position: relative;
    width: 100vw;
    height: 100vh;
}

body {
    /* background: #cbd0d5; */
    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
    font-size: 14px;
    color: #000;
    margin: 0;
    padding: 0;
    width: 100vw;
    height: 100vh;
}

* {
    margin: 0;
    padding: 0;
}

a,
a:link,
a:visited,
a:hover,
a:active,
a:focus {
    text-decoration: none;
    color: #434344;
}
</style>



// WEBPACK FOOTER //
// src/App.vue